var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotInclude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CB2127",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.075 3.526c-3.9-3.9-10.246-3.9-14.146 0A9.94 9.94 0 0 0 0 10.599a9.937 9.937 0 0 0 2.93 7.072 9.971 9.971 0 0 0 7.072 2.925 9.971 9.971 0 0 0 7.073-2.925c3.9-3.9 3.9-10.245 0-14.145zm-1.095 13.05c-3.296 3.295-8.66 3.295-11.955 0a8.398 8.398 0 0 1-2.475-5.977A8.4 8.4 0 0 1 4.025 4.62c3.296-3.296 8.659-3.295 11.955 0 3.295 3.296 3.295 8.66 0 11.954z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.341 12.74-2.193-2.19 2.193-2.19a.776.776 0 0 0-1.096-1.097L10.05 9.455 7.856 7.263A.775.775 0 1 0 6.76 8.36l2.193 2.19-2.193 2.19a.775.775 0 1 0 1.096 1.096l2.195-2.191 2.194 2.191a.775.775 0 1 0 1.095-1.096z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInclude);
export default __webpack_public_path__ + "static/media/not-include.4434ae93073b7306f18c4f687620e901.svg";
export { ForwardRef as ReactComponent };